// Shared notification wrapper (Update 08, Fix 1).
// Centralises auto-dismiss behaviour so it applies everywhere from one place:
//   success  → 3s, info → 5s, error/warning → persist until acknowledged (close button).
import { toast as sonner } from "sonner";

export const notify = {
  success: (message, opts = {}) => sonner.success(message, { duration: 3000, ...opts }),
  info: (message, opts = {}) => sonner.info(message, { duration: 5000, ...opts }),
  message: (message, opts = {}) => sonner(message, { duration: 5000, ...opts }),
  error: (message, opts = {}) => sonner.error(message, { duration: Infinity, ...opts }),
  warning: (message, opts = {}) => sonner.warning(message, { duration: Infinity, ...opts }),
  dismiss: (id) => sonner.dismiss(id),
};

export default notify;
